import { RECEIVE_ANALYTICS_DATA } from '../../actions/analytics';
import monitoringSchema from '../../constants/monitoring/monitoringSchema';

export const initialState = {
  data: { ...monitoringSchema },
};

export default (state = initialState, { type, data } = {}) => {
  switch (type) {
    case RECEIVE_ANALYTICS_DATA:
      return {
        ...state,
        data,
      };

    default:
      return state;
  }
};
